import { useNavigate } from 'react-router-dom';
import {
  FolderOpen,
  Upload,
  Settings
} from 'lucide-react';
import { useAuthStore } from '@/store/auth';

export default function DashboardPage() {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Notion 文件管理器</h1>
        <p className="text-gray-500 mt-1">浏览和管理您的 Notion 文件</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div
          className="card p-6 hover:shadow-md transition-shadow cursor-pointer"
          onClick={() => navigate('/files')}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-100 rounded-xl">
              <FolderOpen className="w-6 h-6 text-blue-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">浏览文件</h3>
              <p className="text-sm text-gray-500">查看页面所有文件</p>
            </div>
          </div>
        </div>

        <div
          className="card p-6 hover:shadow-md transition-shadow cursor-pointer"
          onClick={() => navigate('/upload')}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-green-100 rounded-xl">
              <Upload className="w-6 h-6 text-green-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">上传文件</h3>
              <p className="text-sm text-gray-500">上传文件到 Notion</p>
            </div>
          </div>
        </div>
      </div>

      <div className="card p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-purple-100 rounded-xl">
              <Settings className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">设置</h3>
              <p className="text-sm text-gray-500">配置应用选项</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/settings')}
            className="btn btn-ghost"
          >
            打开设置
          </button>
        </div>
      </div>

      <div className="mt-8 pt-6 border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          退出登录
        </button>
      </div>
    </div>
  );
}